export const ALREADY_DEPLOYED_FROM_ANOTHER_TRANSFORMATION =
    'AlreadyDeployedFromAnotherTransformation';
export const ALREADY_UP_TO_DATE = 'AlreadyUpToDate';
export const ALREADY_USED_AS_PROJECT_INPUT = 'AlreadyUsedAsProjectInput';
export const AMBIGUOUS_COLUMN_REFERENCE = 'AmbiguousColumnReference';
export const ANOTHER_INSTANCE_IS_RESPONSIBLE = 'AnotherInstanceIsResponsible';
export const API_KEY_NOT_FOUND = 'ApiKeyNotFound';
export const API_KEY_OPERATION_NOT_PERMITTED = 'ApiKeyOperationNotPermitted';
export const ASSET_DELETION_NOT_PERMITTED = 'AssetDeletionNotPermitted';
export const ASSET_MODIFICATION_NOT_PERMITTED = 'AssetModificationNotPermitted';
export const ASSET_NAME_ALREADY_EXISTS = 'AssetNameAlreadyExists';
export const ASSET_NOT_DELETABLE = 'AssetNotDeletable';
export const ASSET_NOT_FOUND_BY_SLUG = 'AssetNotFoundBySlug';
export const ASSET_PROPERTY_DEFINITION_ALREADY_EXISTS = 'AssetPropertyDefinitionAlreadyExists';
export const ASSET_PROPERTY_DEFINITION_NOT_FOUND = 'AssetPropertyDefinitionNotFound';
export const ASSET_PROPERTY_DEFINITION_NOT_MODIFIABLE = 'AssetPropertyDefinitionNotModifiable';
export const ASSET_PROPERTY_VALUE_NOT_FOUND = 'AssetPropertyValueNotFound';
export const BLEND_CONDITIONS_EMPTY = 'BlendConditionsEmpty';
export const CANCELED = 'Canceled';
export const CANNOT_CAST_VALUE_OF_TYPE = 'CannotCastValueOfType';
export const CHAT_GPT_ERROR = 'ChatGptError';
export const CHAT_GPT_NOT_CONFIGURED = 'ChatGptNotConfigured';
export const CIRCULAR_REFERENCE = 'CircularReference';
export const CLIENT_CONNECTION_ERROR = 'ClientConnectionError';
export const COLUMN_DOES_NOT_EXIST = 'ColumnDoesNotExist';
export const COLUMN_IS_REFERENCED = 'ColumnIsReferenced';
export const COLUMN_NAME_ALREADY_EXISTS = 'ColumnNameAlreadyExists';
export const COMPILATION_FAILED_WITH_DATASET_ERROR = 'CompilationFailedWithDatasetError';
export const COMPILATION_FAILED_WITH_TRANSFORMATION_ERRORS =
    'CompilationFailedWithTransformationErrors';
export const CONFIG_FAILURE = 'ConfigFailure';
export const CONNECTION_NOT_CONFIGURED = 'ConnectionNotConfigured';
export const DATA_FRESHNESS_CHECK_NOT_MET = 'DataFreshnessCheckNotMet';
export const DATA_LOADING_FAILED = 'DataLoadingFailed';
export const DATA_SOURCE_REFERENCE_NOT_FOUND = 'DataSourceReferenceNotFound';
export const DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED = 'DatabaseNotExistsOrNotAuthorized';
export const DATAMEER_CHANNEL_NOT_FOUND = 'DatameerChannelNotFound';
export const DERIVED_ASSET_MUST_NOT_BE_MODIFIED = 'DerivedAssetMustNotBeModified';
export const DISCOVERY_FAILURE = 'DiscoveryFailure';
export const DUPLICATE_COLUMN_NAMES = 'DuplicateColumnNames';
export const EMAIL_ADDRESS_ALREADY_TAKEN = 'EmailAddressAlreadyTaken';
export const EMAIL_DOMAIN_NOT_AUTHORIZED = 'EmailDomainNotAuthorized';
export const ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE = 'EntityNotFoundOrNotAccessible';
export const EVENT_ID_NOT_FOUND = 'EventIdNotFound';
export const EVENT_SUBSCRIPTION_NOT_FOUND = 'EventSubscriptionNotFound';
export const EXPLORATION_NOT_FOUND = 'ExplorationNotFound';
export const FAILURE_DURING_SUBMISSION = 'FailureDuringSubmission';
export const FILE_FORMAT_CHANGED = 'FileFormatChanged';
export const FILE_FORMAT_NOT_SUPPORTED = 'FileFormatNotSupported';
export const FILE_IS_EMPTY = 'FileIsEmpty';
export const FILE_PARSING_FAILURE = 'FileParsingFailure';
export const FILTER_VALUE_HAS_INCOMPATIBLE_TYPE = 'FilterValueHasIncompatibleType';
export const GITHUB_AUTHENTICATION_ERROR = 'GithubAuthenticationError';
export const GLOSSARY_CATEGORY_EXISTS = 'GlossaryCategoryExists';
export const GLOSSARY_CATEGORY_NAME_UP_TO_DATE = 'GlossaryCategoryNameUpToDate';
export const GLOSSARY_CATEGORY_NOT_FOUND = 'GlossaryCategoryNotFound';
export const GLOSSARY_CATEGORY_STILL_CONTAINS_TERMS = 'GlossaryCategoryStillContainsTerms';
export const GLOSSARY_NOT_MODIFIABLE = 'GlossaryNotModifiable';
export const GLOSSARY_TERM_EXISTS = 'GlossaryTermExists';
export const GLOSSARY_TERM_NOT_FOUND = 'GlossaryTermNotFound';
export const GOOGLE_AUTHENTICATION_FAILED = 'GoogleAuthenticationFailed';
export const GOOGLE_CREDENTIALS_NOT_CONFIGURED = 'GoogleCredentialsNotConfigured';
export const GOOGLE_SHEET_ALREADY_IN_USE = 'GoogleSheetAlreadyInUse';
export const GOOGLE_SHEET_DOES_NOT_EXIST = 'GoogleSheetDoesNotExist';
export const GOOGLE_SPREADSHEET_NOT_ACCESSIBLE = 'GoogleSpreadsheetNotAccessible';
export const GOOGLE_SPREADSHEET_NOT_FOUND = 'GoogleSpreadsheetNotFound';
export const GOOGLE_SPREADSHEET_NOT_WRITABLE = 'GoogleSpreadsheetNotWritable';
export const GROUP_NOT_FOUND = 'GroupNotFound';
export const INSUFFICIENT_PRIVILEGES = 'InsufficientPrivileges';
export const INSUFFICIENT_TASK_PRIVILEGES = 'InsufficientTaskPrivileges';
export const INVALID_ACCESS_TOKEN = 'InvalidAccessToken';
export const INVALID_ACCOUNT_NAME = 'InvalidAccountName';
export const INVALID_EXPRESSION = 'InvalidExpression';
export const INVALID_IDENTIFIER = 'InvalidIdentifier';
export const INVALID_PARAMETER_TYPE_FOR_FUNCTION = 'InvalidParameterTypeForFunction';
export const INVALID_SLACK_CHANNEL_NAME = 'InvalidSlackChannelName';
export const INVALID_SQL_SYNTAX = 'InvalidSqlSyntax';
export const JOB_DEFINITION_NOT_FOUND = 'JobDefinitionNotFound';
export const JOB_RUN_CHECK_FAILED = 'JobRunCheckFailed';
export const JOB_RUN_NOT_CANCELABLE = 'JobRunNotCancelable';
export const JOB_RUN_NOT_FOUND = 'JobRunNotFound';
export const JOB_RUN_SKIPPED = 'JobRunSkipped';
export const MAX_FILE_SIZE_EXCEEDED = 'MaxFileSizeExceeded';
export const MISSING_COLUMN = 'MissingColumn';
export const MISSING_SOURCE_COLUMN = 'MissingSourceColumn';
export const MISSING_TABLE = 'MissingTable';
export const NAME_ALREADY_EXISTS = 'NameAlreadyExists';
export const NAME_CANNOT_BE_BLANK = 'NameCannotBeBlank';
export const NO_ACTIVE_WAREHOUSE_SELECTED = 'NoActiveWarehouseSelected';
export const NO_CSV_CREATED = 'NoCsvCreated';
export const NO_DBT_MODEL_FOUND = 'NoDbtModelFound';
export const NO_DEPLOYMENT_HISTORY = 'NoDeploymentHistory';
export const NO_SAMPLE_FILES_FOUND_BY_PATTERN = 'NoSampleFilesFoundByPattern';
export const NO_WRITABLE_SCHEMA_FOUND = 'NoWritableSchemaFound';
export const NODE_ALREADY_IN_GROUP = 'NodeAlreadyInGroup';
export const NOT_AUTHENTICATED = 'NotAuthenticated';
export const NOT_AUTHENTICATED_TO_SNOWFLAKE = 'NotAuthenticatedToSnowflake';
export const NOT_AUTHORIZED_TO_SLACK = 'NotAuthorizedToSlack';
export const NOT_EXISTS_OR_NOT_AUTHORIZED = 'NotExistsOrNotAuthorized';
export const NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED = 'NotExistsOrOperationCannotBePerformed';
export const NOT_IN_SLACK_CHANNEL = 'NotInSlackChannel';
export const NOT_PERMITTED = 'NotPermitted';
export const NOT_SUSPENDED = 'NotSuspended';
export const OBJECT_ALREADY_EXISTS = 'ObjectAlreadyExists';
export const OPERATION_NOT_PERMITTED = 'OperationNotPermitted';
export const OPERATION_RUN_ERROR = 'OperationRunError';
export const OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS =
    'OutputColumnsWithInvisibleControlCharacters';
export const OUTPUT_COLUMNS_WITH_LINE_SEPARATOR = 'OutputColumnsWithLineSeparator';
export const OWNER_MUST_NOT_BE_ADDED_AS_COLLABORATOR = 'OwnerMustNotBeAddedAsCollaborator';
export const REFERENCED_COLUM_IN_ERROR = 'ReferencedColumInError';
export const REQUIREMENT_NOT_MET = 'RequirementNotMet';
export const SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED = 'SchemaNotExistsOrNotAuthorized';
export const SECRET_NOT_FOUND = 'SecretNotFound';
export const SELF_REFERENCE = 'SelfReference';
export const SEQUENTIAL_JOB_RUN_CHECK_NOT_MET = 'SequentialJobRunCheckNotMet';
export const SHARE_NOT_FOUND = 'ShareNotFound';
export const SLACK_API_CALL_FAILED = 'SlackApiCallFailed';
export const SLACK_CHANNEL_NOT_FOUND = 'SlackChannelNotFound';
export const SLACK_NOT_CONFIGURED = 'SlackNotConfigured';
export const SNOWFLAKE_ACCOUNT_NOT_EXISTS_OR_NOT_ACCESSIBLE =
    'SnowflakeAccountNotExistsOrNotAccessible';
export const SNOWFLAKE_INTERNAL_SERVER_ERROR = 'SnowflakeInternalServerError';
export const SNOWFLAKE_NOT_CONFIGURED = 'SnowflakeNotConfigured';
export const SNOWFLAKE_OBJECT_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'SnowflakeObjectNotFoundOrNotAccessible';
export const SNOWFLAKE_OUTPUT_ALREADY_EXISTS = 'SnowflakeOutputAlreadyExists';
export const SNOWFLAKE_QUERY_CANCELED = 'SnowflakeQueryCanceled';
export const SNOWFLAKE_SERVICE_ACCOUNT_USER_NOT_EXISTS = 'SnowflakeServiceAccountUserNotExists';
export const SNOWFLAKE_TABLE_ALREADY_EXISTS = 'SnowflakeTableAlreadyExists';
export const SOURCE_TRANSFORMATION_NOT_FOUND = 'SourceTransformationNotFound';
export const SOURCE_VIEW_NOT_EXCHANGEABLE = 'SourceViewNotExchangeable';
export const SQL_NOT_MODIFIED = 'SqlNotModified';
export const TABLE_ALREADY_EXISTS = 'TableAlreadyExists';
export const TARGET_TABLE_NOT_EXISTS = 'TargetTableNotExists';
export const TARGET_VIEW_OR_TABLE_NOT_ALLOWED_TO_OVERWRITE =
    'TargetViewOrTableNotAllowedToOverwrite';
export const TIMEOUT = 'Timeout';
export const TOKEN_EXPIRED = 'TokenExpired';
export const TOO_MANY_ENABLED_USERS = 'TooManyEnabledUsers';
export const TRANSFORMATION_NOT_OPERATIONAL = 'TransformationNotOperational';
export const UNCATEGORIZED_SQL_ERROR = 'UncategorizedSqlError';
export const UNEXPECTED_FAILURE = 'UnexpectedFailure';
export const UNKNOWN_COLUMN_REFERENCE = 'UnknownColumnReference';
export const UNKNOWN_FUNCTION = 'UnknownFunction';
export const UNKNOWN_FUNCTIONS = 'UnknownFunctions';
export const UPDATING_OWN_GROUP_NOT_ALLOWED = 'UpdatingOwnGroupNotAllowed';
export const UPLOAD_NOT_FOUND = 'UploadNotFound';
export const USER_ALREADY_DISABLED = 'UserAlreadyDisabled';
export const USER_ALREADY_ENABLED = 'UserAlreadyEnabled';
export const USER_CANNOT_DISABLE_ITSELF = 'UserCannotDisableItself';
export const USER_DIFFERS_FROM_TOKEN = 'UserDiffersFromToken';
export const USER_NOT_FOUND = 'UserNotFound';
export const USER_RELATED_DATA_NOT_FOUND = 'UserRelatedDataNotFound';
export const USERNAME_ALREADY_TAKEN = 'UsernameAlreadyTaken';
export const USERNAME_INVALID = 'UsernameInvalid';
export const VALUE_NOT_RECOGNIZED = 'ValueNotRecognized';
export const VIEW_ALREADY_EXISTS = 'ViewAlreadyExists';
export const VIEW_IS_A_REFERENCE = 'ViewIsAReference';
export const VIEW_WITH_SAME_NAME_ALREADY_EXISTS = 'ViewWithSameNameAlreadyExists';
export const WAREHOUSE_SUSPENDED = 'WarehouseSuspended';
export const UNKNOWN_COLUMN_NAMES = 'UnknownColumnNames'; 
export const UNKNOWN_COLUMN_NAMES_WITH_SOURCE = 'UnknownColumnNamesWithSource';
export const DUPLICATE_COLUMN_NAME = 'DuplicateColumnName'
export const COLUMN_REMOVED_UPSTREAM = 'ColumnRemovedUpstream';
export const TYPES_NOT_COERCIBLE = 'TypesNotCoercible';
export const TYPE_COERCION = 'TypeCoercion';
export const TRANSFORMATION_OUT_OF_SYNC = 'TransformationSqlOutOfSync';
export const COLUMN_ADDED_UPSTREAM = 'ColumnAddedUpstream';
export const MODEL_NOT_RESOLVED = 'ModelNotFinalized';
export const MODEL_NOT_CONNECTED = 'ModelNotConnected';
export const HAS_DRAFT_MODEL_UPSTREAM = 'HasDraftModelUpstream';
export const UNEXPECTED_COLUMN = 'UnexpectedColumn';
export const EXPECTED_COLUMN_MISSING = 'ExpectedColumnMissing';
export const MATERIALIZATION_CANNOT_BE_DELETED = 'europa.space.MaterializationOperationCannotBeDeleted';
export const MULTI_SOURCE_CANNOT_BE_DELETED = 'europa.space.MultiSourceNodeCannotBeDeleted';
export const SOURCE_CANNOT_BE_DELETED = 'europa.space.SourceNodeCannotBeDeleted';
